import { createContext, useContext, useState } from "react";

const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [loginMessage, setLoginMessage] = useState("");

  const showLoginMessage = (message) => {
    setLoginMessage(message);
    setTimeout(() => setLoginMessage(""), 3000); 
  };

  return (
    <LoginContext.Provider value={{ loginMessage, showLoginMessage }}>
      {children}
    </LoginContext.Provider>
  );
};

export const useLoginContext = () => useContext(LoginContext);
